export default __webpack_public_path__ + "land-use-plan-800-a2bc661e2e721b72583f9bb414c911d5.png";